const endpoint = "https://oepb.cuba-go.com"
const cpoint = "https://central-backend.cuba-go.com"

const mediapoint = `${cpoint}/electronic`
const startpoint = `${cpoint}/oep/`

export { endpoint, mediapoint, startpoint, cpoint }
